export default "__VITE_ASSET__DPgJzxma__"